import Header from '../Header/Header';
import { Link, useNavigate } from 'react-router-dom';
import Footer from "../../Landing/Footer/Footer";
import { ToastContainer, toast } from "react-toastify";
import blog_icon13 from "../../../screenassets/images/cta/02.png";
import { useState } from 'react';


export default function Contact() {

    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [message, setMessage] = useState();

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!name) {
            toast.info("Name field is required!");
            return;
        }
        if (!email) {
            toast.info("Email field is required!");
            return;
        }
        if (!message) {
            toast.info("Message field is required!");
            return;
        }

        const post_data = {
            name: name,
            email: email,
            message: message,
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/service/createContact`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(post_data),
            });
            const data = await response.json();

            if (data.status === true) {
                setName("");
                setEmail("");
                setMessage("");
                toast.success("Message successfully submitted!");
            } else {
                toast.error("Failed to submit message. Please try again.");
            }

        } catch (error) {
            toast.error("Something went wrong! Please try again later.");
        }

    };

    return (
        <>
            {/* Header Section */}
            <Header />

            <ToastContainer position="top-right" autoClose={3000} />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Contact Us</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Contact</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="rts-contact-form-area rts-section-gap">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-4 col-md-12">
                            <div id="form-messages"></div>

                            <form id="contact-form" className="contact-page-form" onSubmit={(event) => { handleSubmit(event) }}>
                                <h3 className="title">Get In Touch</h3>

                                <div className="single-input">
                                    <label htmlFor="name">Your Name</label>
                                    <input type="text" value={name} onChange={(event) => { setName(event.target.value) }} placeholder="Full name" />
                                    <i className="fa-regular fa-user"></i>
                                </div>

                                <div className="single-input">
                                    <label htmlFor="email">Your Email Address</label>
                                    <input type="email" value={email} onChange={(event) => { setEmail(event.target.value) }} placeholder="Email" />
                                    <i className="fa-regular fa-envelope"></i>
                                </div>

                                <div className="single-input">
                                    <label htmlFor="textarea">Enter Your Message</label>
                                    <textarea value={message} onChange={(event) => { setMessage(event.target.value) }} placeholder="Write here your details message" ></textarea>
                                    <i className="fa-solid fa-marker"></i>
                                </div>
                                <div className="single-input">
                                    <button type='submit' className="rts-btn btn-primary">Send Message</button>
                                </div>
                            </form>

                        </div>

                        <div className="col-lg-8 col-md-12">
                            <div className="map-area-start">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4869117625312!2d88.46491737600687!3d22.969115918319567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89569b468a613%3A0xb71acdd2b15d7dac!2sKalyani!5e0!3m2!1sen!2sin!4v1757319660912!5m2!1sen!2sin"
                                    width="600"
                                    height="520"
                                    style={{ border: "0px" }}
                                    allowfullscreen=""
                                    loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            {/* <div className="card-contact-page-area rts-section-gapBottom">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12">
                            <div className="single-card-area-wrapper">
                                <h5 className="title">Sales</h5>
                                <p className="dsic">
                                    Need help? Our support team is available to answer of 24x7
                                </p>
                                <Link to="#" className="rts-btn btn-primary"> Talk To Us <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                            </div>

                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12">

                            <div className="single-card-area-wrapper">
                                <h5 className="title">24X7 Support</h5>
                                <p className="dsic">
                                    Need help? Our support team is available to answer of 24x7
                                </p>
                                <Link to="#" className="rts-btn btn-primary" >Talk To Us <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                            </div>

                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12">

                            <div className="single-card-area-wrapper">
                                <h5 className="title">Partnership</h5>
                                <p className="dsic">
                                    Partner with us? Reach out and we'll explore all opportunities.
                                </p>
                                <Link to="#" className="rts-btn btn-primary" >Talk To Us <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                            </div>

                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12 col-12">

                            <div className="single-card-area-wrapper">
                                <h5 className="title">Request Demo</h5>
                                <p className="dsic">
                                    Have an out of the box idea for a new AI Demo to add.
                                </p>
                                <Link to="#" className="rts-btn btn-primary" >Talk To Us <FaArrowRightLong style={{ marginLeft: "10px" }} /></Link>
                            </div>

                        </div>
                    </div>
                </div>
            </div> */}


            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to simplify <br />
                                        your studies?
                                    </h3>
                                    <Link to="/about" className="rts-btn btn-primary text-white">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={blog_icon13} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Footer Section */}
            <Footer />

        </>
    )
}
